// extracted by mini-css-extract-plugin
export default {"componentContainer":"Title_componentContainer__TstM+","contTitle":"Title_contTitle__qez0+","par":"Title_par__fUCMr","showMoreIcon":"Title_showMoreIcon__CY6jA"};